export interface CustomerSearchTarget {
  id?: number | string;
  idCustomer?: number | string;
  firstName?: string | null;
  lastName?: string | null;
  displayName?: string | null;
}

const normalizeSearchText = (value: any): string =>
  String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const searchTokens = (value: any): string[] =>
  normalizeSearchText(value)
    .split(/[\s,.;:/\\|()[\]{}'"`~!?@#$%^&*_+=<>-]+/)
    .filter(Boolean);

const customerNameTokens = (customer: CustomerSearchTarget): string[] => [
  ...searchTokens(customer.firstName),
  ...searchTokens(customer.lastName),
  ...searchTokens(customer.displayName),
];

export const customerMatchesNameSearch = (
  customer: CustomerSearchTarget,
  value: any,
): boolean => {
  const queryTokens = searchTokens(value);
  if (!queryTokens.length) return true;

  const nameTokens = customerNameTokens(customer);
  if (!nameTokens.length) return false;

  return queryTokens.every((queryToken) =>
    nameTokens.some((nameToken) => nameToken.startsWith(queryToken)),
  );
};

export const mergeCustomerSearchResults = <T extends CustomerSearchTarget>(
  nameMatches: T[],
  fuzzyMatches: T[],
): T[] => {
  const seen = new Set<string>();
  const results: T[] = [];

  for (const customer of [...nameMatches, ...fuzzyMatches]) {
    const id = String(customer.idCustomer ?? customer.id ?? JSON.stringify(customer));
    if (!seen.has(id)) {
      seen.add(id);
      results.push(customer);
    }
  }

  return results;
};
